import { createSelector } from 'reselect'

import * as Process from './process'
import { getArgN } from './utils'

export const get = createSelector([ Process.get, getArgN(2) ], (process, nodeID) => {
  if (!process) return
  return process.nodes.find(n => n.id === nodeID)
})



// WEBPACK FOOTER //
// ../webmango-core/selectors/node.js